export default __webpack_public_path__ + "static/media/7.49da3d0c.svg";